import React from "react";
import { compose } from "recompose";
import { Trans } from "react-i18next";
import { Table } from "reactstrap";
import { TableContainer, withTable } from "components/common";
import { withXeroErrors, XeroTableDataFetch } from "components";
import { formatCurrency } from "services/util";
import { compact } from "lodash";
import { Link, withRouter } from "react-router-dom";

export const AwaitingAuthorisation = ({
  data,
  ordering,
  url = "expenseclaims",
  filters,
  match,
  setData,
  setXeroErrors,
  setOrdering,
  limit,
  offset,
}) => (
  <div>
    <TableContainer
      idKey="ExpenseClaimID"
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
    >
      <Table size="sm">
        <thead>
          <tr>
            <th sortBy="User.FirstName">
              <Trans>Name</Trans>
            </th>
            <th>
              <Trans>Total</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {data.results.map((i, idx) => (
            <tr key={i.ExpenseClaimID}>
              <td>
                <Link to={`${match.url}/${i.ExpenseClaimID}`}>
                  {compact([i.User.FirstName, i.User.LastName]).join(" ")}
                </Link>
              </td>
              <td>{formatCurrency(i.Total)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <XeroTableDataFetch
      ordering={ordering}
      limit={limit}
      url={url}
      filters={filters}
      offset={offset}
      onDataFetched={setData}
      onDataError={setXeroErrors}
    />
  </div>
);

export const enhance = compose(
  withRouter,
  withTable({
    idKey: "ExpenseClaimID",
    filters: {
      raw: 'Status="SUBMITTED" AND Total>0',
    },
  }),
  withXeroErrors()
);

export default enhance(AwaitingAuthorisation);
